import { motion } from "framer-motion";
import { Phone, Mail, Facebook, ArrowUpRight } from "lucide-react";
import { fadeUp, PrimaryCTA, SecondaryCTA } from "./shared";

export const Contact = () => (
    <section
        id="kapcsolat"
        data-testid="contact-section"
        className="relative bg-[#0A0A0A] text-white py-24 sm:py-32 lg:py-40 overflow-hidden grain"
    >
        <div
            className="absolute inset-0 opacity-25 bg-cover bg-center pointer-events-none"
            style={{ backgroundImage: "url(/images/solar.png)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]" />

        <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-100px" }}
            >
                <div className="flex items-center gap-4">
                    <span className="section-num">05</span>
                    <span className="h-px w-10 bg-[#0D7A73]" />
                    <span className="font-mono-label text-xs text-white/70">
                        Ajánlatkérés
                    </span>
                </div>
                <h2 className="mt-6 font-display-alt font-extrabold text-5xl sm:text-6xl lg:text-8xl leading-[0.95] max-w-5xl">
                    Készen áll
                    <br />
                    <span className="text-[#7ED4CE]">a stabilabb</span>
                    <br />
                    jövőre?
                </h2>
                <p className="mt-8 text-white/75 text-lg sm:text-xl max-w-2xl leading-relaxed">
                    A pontos árajánlat elkészítéséhez minden esetben helyszíni felmérés szükséges.
                </p>
            </motion.div>

            <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-px bg-white/15 border border-white/15">
                <motion.a
                    variants={fadeUp}
                    custom={1}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    href="tel:+36706534187"
                    data-testid="contact-phone"
                    className="group bg-[#0A0A0A] p-8 sm:p-10 flex flex-col gap-6 hover:bg-[#0D7A73] transition-colors duration-300"
                >
                    <Phone className="w-8 h-8 text-[#7ED4CE] group-hover:text-white" />
                    <div>
                        <div className="font-mono-label text-xs text-white/50 group-hover:text-white/80">
                            Telefon
                        </div>
                        <div className="font-display font-bold text-2xl sm:text-3xl mt-2 tabular">
                            +36 70 653 4187
                        </div>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-white/80 mt-auto">
                        Hívjon most
                        <ArrowUpRight className="cta-arrow w-4 h-4" />
                    </div>
                </motion.a>

                <motion.a
                    variants={fadeUp}
                    custom={2}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    href="mailto:iroda@stabilor.hu"
                    data-testid="contact-email"
                    className="group bg-[#0A0A0A] p-8 sm:p-10 flex flex-col gap-6 hover:bg-[#0D7A73] transition-colors duration-300"
                >
                    <Mail className="w-8 h-8 text-[#7ED4CE] group-hover:text-white" />
                    <div>
                        <div className="font-mono-label text-xs text-white/50 group-hover:text-white/80">
                            Email
                        </div>
                        <div className="font-display font-bold text-xl sm:text-2xl mt-2 break-all">
                            iroda@stabilor.hu
                        </div>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-white/80 mt-auto">
                        Írjon nekünk
                        <ArrowUpRight className="cta-arrow w-4 h-4" />
                    </div>
                </motion.a>

                <motion.a
                    variants={fadeUp}
                    custom={3}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    href="https://www.facebook.com/profile.php?id=61594124643214"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-facebook"
                    className="group bg-[#0A0A0A] p-8 sm:p-10 flex flex-col gap-6 hover:bg-[#0D7A73] transition-colors duration-300"
                >
                    <Facebook className="w-8 h-8 text-[#7ED4CE] group-hover:text-white" />
                    <div>
                        <div className="font-mono-label text-xs text-white/50 group-hover:text-white/80">
                            Közösség
                        </div>
                        <div className="font-display font-bold text-2xl sm:text-3xl mt-2">
                            Facebook
                        </div>
                        <div className="text-white/70 text-sm mt-2 group-hover:text-white/90">
                            Kövessen minket projektjeinkért
                        </div>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-white/80 mt-auto">
                        Megnyitás
                        <ArrowUpRight className="cta-arrow w-4 h-4" />
                    </div>
                </motion.a>
            </div>

            <motion.div
                variants={fadeUp}
                custom={4}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                className="mt-16 flex flex-col sm:flex-row items-start sm:items-center gap-6"
            >
                <PrimaryCTA testId="contact-cta-primary" href="tel:+36706534187" dark>
                    Telefonos egyeztetés
                </PrimaryCTA>
                <SecondaryCTA
                    testId="contact-cta-secondary"
                    href="mailto:iroda@stabilor.hu"
                    light
                >
                    Email küldése
                </SecondaryCTA>
                <div className="text-white/60 text-sm font-mono-label sm:ml-4">
                    Ingyenes telefonos konzultáció
                </div>
            </motion.div>
        </div>
    </section>
);
